var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { attrs: { cols: "12" } },
    [
      _c(
        "v-form",
        { ref: "form" },
        [
          _c(
            "base-card",
            [
              _c("v-card-title", [_vm._v("Facturas Electrónicas")]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "4" } },
                        [
                          _c(
                            "v-dialog",
                            {
                              ref: "dialog",
                              attrs: {
                                "return-value": _vm.dates,
                                persistent: "",
                                width: "290px",
                              },
                              on: {
                                "update:returnValue": function ($event) {
                                  _vm.dates = $event
                                },
                                "update:return-value": function ($event) {
                                  _vm.dates = $event
                                },
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                label: "Rango de fechas",
                                                "prepend-icon": "mdi-calendar",
                                                readonly: "",
                                              },
                                              model: {
                                                value: _vm.dates,
                                                callback: function ($$v) {
                                                  _vm.dates = $$v
                                                },
                                                expression: "dates",
                                              },
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.modal,
                                callback: function ($$v) {
                                  _vm.modal = $$v
                                },
                                expression: "modal",
                              },
                            },
                            [
                              _c(
                                "v-date-picker",
                                {
                                  attrs: {
                                    locale: "es",
                                    "show-current": "true",
                                    range: _vm.isAdminID || _vm.isDev,
                                  },
                                  model: {
                                    value: _vm.dates,
                                    callback: function ($$v) {
                                      _vm.dates = $$v
                                    },
                                    expression: "dates",
                                  },
                                },
                                [
                                  _c("v-spacer"),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { text: "", color: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.getCleanDateCurrent()
                                        },
                                      },
                                    },
                                    [_vm._v(" Limpiar ")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { text: "", color: "primary" },
                                      on: {
                                        click: function ($event) {
                                          _vm.modal = false
                                        },
                                      },
                                    },
                                    [_vm._v(" Cancel ")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { text: "", color: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$refs.dialog.save(
                                            _vm.dates
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" OK ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.hasElevatedRole
                        ? _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-select", {
                                ref: "cliente",
                                attrs: {
                                  items: _vm.detailClients,
                                  "item-text": "text",
                                  "item-value": "IdCompania",
                                  label: "Compañia",
                                  "prepend-inner-icon": "mdi-sitemap",
                                  rules: _vm.formRules,
                                  "error-messages": _vm.errorMessages,
                                  filter: "",
                                  "search-input": "",
                                  required: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    _vm.hasElevatedRole
                                      ? {
                                          key: "prepend-item",
                                          fn: function () {
                                            return [
                                              _c(
                                                "v-list-item",
                                                [
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _c(
                                                        "v-list-item-title",
                                                        [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "search-field",
                                                            attrs: {
                                                              placeholder:
                                                                "Buscar",
                                                              "prepend-inner-icon":
                                                                "mdi-magnify",
                                                              "hide-details":
                                                                "",
                                                            },
                                                            model: {
                                                              value: _vm.search,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.search =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "search",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        }
                                      : null,
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: _vm.dataFilter.IdCompania,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataFilter, "IdCompania", $$v)
                                  },
                                  expression: "dataFilter.IdCompania",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "4" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.origin,
                              "item-text": "textOrigin",
                              "item-value": "valueOrigin",
                              label: "Origen Transacción",
                              "prepend-inner-icon": "mdi-adjust",
                            },
                            model: {
                              value: _vm.dataFilter.origin,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataFilter, "origin", $$v)
                              },
                              expression: "dataFilter.origin",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "4" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.typeStatus,
                              "item-text": "textStatus",
                              "item-value": "valueStatus",
                              label: "Estado",
                              "prepend-inner-icon":
                                "mdi-order-bool-descending-variant",
                            },
                            model: {
                              value: _vm.dataFilter.Status,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataFilter, "Status", $$v)
                              },
                              expression: "dataFilter.Status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _vm.showPrefixField
                        ? _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Prefijo",
                                  "prepend-inner-icon": "mdi-file",
                                },
                                model: {
                                  value: _vm.dataFilter.Prefix,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataFilter, "Prefix", $$v)
                                  },
                                  expression: "dataFilter.Prefix",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "4" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label:
                                "Número de factura (Prefijo y consecutivo)",
                              "prepend-inner-icon": "mdi-note-multiple",
                              rules: _vm.invoiceNumberRules,
                            },
                            model: {
                              value: _vm.dataFilter.Consecutivo,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataFilter, "Consecutivo", $$v)
                              },
                              expression: "dataFilter.Consecutivo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { cols: "12", sm: "4" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-2",
                              staticStyle: {
                                "background-color": "rgb(204 33 40)",
                                color: "white !important",
                              },
                              on: { click: _vm.searchInvoice },
                            },
                            [_vm._v(" Buscar ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-2",
                              attrs: { color: "GRAY" },
                              on: { click: _vm.clearForm },
                            },
                            [_vm._v(" Nueva Búsqueda ")]
                          ),
                        ],
                        1
                      ),
                      _vm.searchInvoiceProgress == true
                        ? _c(
                            "v-row",
                            {
                              staticClass: "fill-height",
                              attrs: {
                                "align-content": "center",
                                justify: "center",
                              },
                            },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "text-subtitle-1 text-center",
                                      attrs: { cols: "12" },
                                    },
                                    [_vm._v(" Consultando Facturas ")]
                                  ),
                                  _c("v-progress-linear", {
                                    attrs: {
                                      color: "red darken-4",
                                      indeterminate: "",
                                      rounded: "",
                                      height: "6",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-alert",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.successAlert,
                              expression: "successAlert",
                            },
                          ],
                          attrs: { type: "success", text: "" },
                        },
                        [_vm._v(" " + _vm._s(_vm.msgSuccessAlert) + " ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _vm.showAlert
                            ? _c(
                                "v-alert",
                                { attrs: { type: _vm.alertType, text: "" } },
                                [_vm._v(" " + _vm._s(_vm.alertMessage) + " ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }